import { z } from "zod";

import { defaultItem, defaultUrl, transformerMdContentParam, itemSchema, urlSchema } from "../shared";
import { createId } from "@paralleldrive/cuid2";

// Schema
export const certificationSchema = itemSchema.extend({
  name: z.string().min(1),
  issuer: z.string(),
  date: z.string(),
  summary: transformerMdContentParam,
  url: urlSchema,
});

export const minimalCertificationSchema = certificationSchema.omit({
  id: true,
  visible: true,
});

// Type
export type Certification = z.infer<typeof certificationSchema>;
export type MinimalCertification = z.infer<typeof minimalCertificationSchema>;

// Defaults
export const defaultCertification: Certification = {
  ...defaultItem,
  name: "",
  issuer: "",
  date: "",
  summary: "",
  url: defaultUrl,
};

export const deminimalizeCertification = (certification: MinimalCertification): Certification => {
  return {
    ...defaultCertification,
    ...certification,
    id: createId(),
  };
};
